import React, { useEffect, useState } from 'react';

import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/Login/Login';
import useToken from './components/Login/useToken';

import { Capacitor } from '@capacitor/core';
import { setupIonicReact, IonApp, IonLabel, IonModal, IonContent, IonButtons, IonButton, IonHeader, IonToolbar, IonTitle } from '@ionic/react';
import { themeDetector } from 'citric_components';

import CardImg from './images/card.png';
//import AppInitializer from './components/AppInitializer/AppInitializer';
/*import SqliteService from './services/sqliteService';
import DbVersionService from './services/dbVersionService';
import StorageService  from './services/storageService';*/

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import '@ionic/react/css/palettes/dark.class.css';

import './App.scss';
import './App.css';
import ErrorBoundary from './components/Error/ErrorBoundary';
//import 'bootstrap/dist/css/bootstrap.min.css';

export const platform = Capacitor.getPlatform();

// Singleton Services
/*export const SqliteServiceContext = React.createContext(SqliteService);
export const DbVersionServiceContext = React.createContext(DbVersionService);
export const StorageServiceContext = React.createContext(new StorageService(SqliteService,DbVersionService));*/


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
        es: {
            translation: {
                App: "Aplicación",
                user: "Usuario",
                password: "Contraseña",
                rememberme: "Recuerdame",
                login: "Login",
                no_login: "Usuario o contraseña incorrectos",
                spanish: "Español",
                english: "Inglés",
                finished: 'Finalizado',
                complete: 'Finalizado',
                screenout: 'Descartada',
                open: 'Abandono',
                dropout: 'Abandono',
                discarded: 'Descartada',
                quotafull: 'Cuota Full',
                answer: 'Respuesta',
                times: 'Veces',
                percentage: 'Porcentaje',
                quota: 'Cuota',
                cross_quotas: 'Cruzar cuotas',
                percentage_quota: '% Cuota',
                missing: 'Faltan',
                total: 'Total',
                tracking: 'Seguimiento',
                select_form: 'Selecciona una encuesta',
                select_quota: 'Selecciona una cuota',
                select_question: 'Selecciona una pregunta',
                all_todas: 'Todas',
                no_data: 'No hay datos',
                no_quotas: 'No hay cuotas',
                no_questions: 'No hay preguntas',
                contact_us: 'Contacta con nosotros',
                customers: 'Clientes',
                outputs: 'Outputs',
                mail: 'Email',
                format: 'Formato',
                scheduled: 'Programado',
                file: 'Archivo',
                type_file: 'Tipo de archivo',
                load: 'Cargar',
                last_update: 'Última actualización',
                survey: 'Encuesta',
                //Tracking
                loi: 'LOI',
                questions: 'Preguntas',
                screenouts: 'Screenouts',
                edit_quotas: 'Editar cuotas',
                cross_quotas: 'Cruzar cuotas',
                access: 'Accesos',
                profile_quota: 'Cuota perfil',
                //Brandlift
                brandlift: 'Brand Lift',
                channels: 'Canales',
                current_exp: 'Finalizados EXP',
                total_exp: 'Total EXP',
                current_ne: 'Finalizados NE',
                total_ne: 'Total NE',
                output_exp: 'EXP',
                output_ne: 'NE',
                report: 'Informe',
                budget: 'Presupuesto',
                invoice: 'Factura',
                brandlift_projects: 'Proyectos Brand Lift',
                launched: 'Lanzado',
                submited: 'Entregado',
                invoiced: 'Facturado',
                finished: 'Finalizado',
                paid: 'Pagado',
                pending: 'Pendiente',
                past_due: 'Vencido',
                vat: 'IVA',
                amount: 'Cantidad',
                invoice_state: 'Estado de factura',
                //Cati
                change_state: 'Cambiar estado',
                begin: 'Empezar',
                followup: 'Seguimiento',
                more_interviewees: 'Más Entrevistados',
                next_interviewed: 'Siguiente Entrevistado',
                new_interviewed: 'Nuevo entrevistado',
                fin_entrevista: 'Fin entrevista',
                no_continua: 'No continua',
                no_contesta: 'No contesta',
                error_fax: 'Error fax',
                error_tlf: 'Error teléfono',
                error_tlf_inc: 'Teléfono incorrecto',
                aplazar: 'Aplazar',
                otros: 'Otros',
                llamar: 'Llamar',
                dar_baja: 'Baja',
                unsubscribe: 'Dar de baja',
                asignado: 'Asignado',
                emp_entrevista: 'Empezar entrevista',
                cargar_usu: 'Cargar entrevistado',
                cargar_usu_al: 'Cargar entrevistado aleatorio',
                interviewed: 'Entrevistado',
                click_begin_hangout: 'Cuando su llamada sea recepcionada, haz click en el botón "Empezar"',
                calendar: 'Calendario',
                number: 'Número',
                alias: 'Alias',
                upcoming_events: 'Próximos eventos',
                no_events: 'No hay eventos',
                exists_name_number: 'Ya existe un entrevistado con este alias o número',
                empty_name: 'El alias no puede estar vacío',
                confirm_unsubscribe: '¿Confirma que desea dar de baja a este entrevistado?',
                //Popups
                add_note: 'Añadir nota',
                logged_as: 'Has iniciado sesión como',
                logged_in_as: 'Bienvenido,',
                user_want_continue: '¿Quieres continuar con este usuario?',
                //Menus
                surveys: 'Encuestas',
                projects: 'Proyectos',
                start_survey: 'Empezar',
                history: 'Historial',
                toogle_theme: 'Cambiar tema',
                //Tables
                id: 'ID',
                actions: 'Acciones',
                code: 'Código',
                name: 'Nombre',
                desc: 'Descripción',
                summary: 'Resumen',
                excel: 'Exportar',
                interviewer: 'Entrevistador',
                planning: 'Planificación',
                start: 'Inicio',
                started: 'Inicio',
                modified: 'Modificado',
                end: 'Fin',
                state: 'Estado',
                remoteuser: 'Usuario remoto',
                note: 'Nota',
                downloads: 'Descargas',
                //Buttons
                continue: 'Continuar',
                cancel: 'Cancelar',
                confirm: 'Confirmar',
                close: 'Cerrar',
                change: 'Cambiar',
                //Error
                error: 'Ha ocurrido un error, vuelva a intentarlo más tarde. Si el error persiste contacte con nosotros. Refresca la página para continuar',
                went_wrong: "Algo ha ido mal, el error ha sido enviado a nuestro equipo",
                reload_continue: "Refresca la página para continuar",
                click_reload: "¡Click para refrescar!",
                close_session: 'Cerrar sesión',
                bad_url: 'La url introducida es incorrecta. Compruébela.',
                login_changepass: "Hay un problema con tu cuenta, por favor con nosotros",
                login_timedout: "Hay un problema con tu cuenta, por favor con nosotros",
                login_exceeded: "Hay un problema con tu cuenta, por favor con nosotros",
                login_no: "Comprueba tu usuario y contraseña"
            }
        },
        en: {
            translation: {
                App: "Application",
                user: "User",
                password: "Password",
                rememberme: "Remember me",
                login: "Login",
                no_login: "Wrong username or password",
                spanish: "Spanish",
                english: "English",
                finished: 'Finished',
                complete: 'Complete',
                dropout: 'Dropout',
                screenout: 'ScreenOut',
                open: 'Open',
                discarded: 'Discarded',
                quotafull: 'Quota Full',
                answer: 'Answer',
                times: 'Times',
                percentage: 'Percentage',
                quota: 'Quota',
                cross_quotas: 'Cross quotas',
                percentage_quota: '% Quota',
                missing: 'Missing',
                total: 'Total',
                tracking: 'Tracking',
                select_form: 'Select a survey',
                select_quota: 'Select a quota',
                select_question: 'Selecciona a question',
                all_todas: 'All',
                no_data: 'No data',
                no_quotas: 'No quotas',
                no_questions: 'No questions',
                contact_us: 'Contact us',
                customers: 'Customers',
                outputs: 'Outputs',
                mail: 'Email',
                format: 'Format',
                scheduled: 'Scheduled',
                file: 'File',
                type_file: 'Type file',
                load: 'Load',
                last_update: 'Last update',
                survey: 'Survey',
                //Tracking
                loi: 'LOI',
                questions: 'Questions',
                screenouts: 'Screenouts',
                edit_quotas: 'Edit quotas',
                cross_quotas: 'Cross quotas',
                access: 'Access',
                profile_quota: 'Profile quota',
                //Brandlift
                brandlift: 'Brand Lift',
                channels: 'Channels',
                current_exp: 'Completed EXP',
                total_exp: 'Total EXP',
                current_ne: 'Completed NE',
                total_ne: 'Total NE',
                output_exp: 'EXP',
                output_ne: 'NE',
                report: 'Report',
                budget: 'Budget',
                invoice: 'Invoice',
                brandlift_projects: 'Brand Lift Projects',
                launched: 'Launched',
                submited: 'Submited',
                invoiced: 'Invoiced',
                finished: 'Finished',
                paid: 'Paid',
                pending: 'Pending',
                past_due: 'Past Due',
                vat: 'VAT',
                amount: 'Amount',
                invoice_state: 'Invoice State',
                //Cati
                change_state: 'Change status',
                begin: 'Start',
                followup: 'Follow-up',
                more_interviewees: 'More interviewees',
                next_interviewed: 'Next interviewee',
                new_interviewed: 'New interviewee',
                fin_entrevista: 'End interview',
                no_continua: 'Does not continue',
                no_contesta: 'No answer',
                error_fax: 'Fax error',
                error_tlf: 'Phone error',
                error_tlf_inc: 'Incorrect phone number',
                aplazar: 'Postpone',
                otros: 'Others',
                llamar: 'Call',
                dar_baja: 'Unsubscribed',
                unsubscribe: 'Unsubscribe',
                asignado: 'Assigned',
                emp_entrevista: 'Begin interview',
                cargar_usu: 'Load interviewee',
                cargar_usu_al: 'Load random interviewee',
                interviewed: 'Interviewed',
                click_begin_hangout: 'When your call is received, click the "Start" button',
                calendar: 'Calendar',
                number: 'Number',
                alias: 'Alias',
                upcoming_events: 'Upcoming events',
                no_events: 'No events',
                exists_name_number: 'There is already an interviewee with this name or number',
                empty_name: 'The name cannot be empty',
                confirm_unsubscribe: 'Do you confirm you want to unsubscribe this interviewee?',
                //Popups
                add_note: 'Add note',
                logged_as: 'You are logged in as',
                logged_in_as: 'Welcome,',
                user_want_continue: 'Do you want to continue with this user?',
                //Menus
                surveys: 'Surveys',
                projects: 'Projects',
                start_survey: 'Start',
                history: 'History',
                toogle_theme: 'Toggle theme',
                //Tables
                id: 'ID',
                actions: 'Actions',
                code: 'Code',
                name: 'Name',
                desc: 'Description',
                summary: 'Summary',
                excel: 'Export',
                interviewer: 'Interviewer',
                planning: 'Planning',
                start: 'Started',
                started: 'Started',
                modified: 'Modified',
                end: 'End',
                state: 'State',
                remoteuser: 'Remote user',
                note: 'Note',
                downloads: 'Downloads',
                //Buttons
                continue: 'Continue',
                cancel: 'Cancel',
                confirm: 'Confirm',
                close: 'Close',
                change: 'Change',
                //Error
                error: 'An error has occurred, please try again later. If the error persists contact us. Reload the page to continue',
                went_wrong: "Something went wrong, the error has been sent to our team",
                reload_continue: "Reload the page to continue",
                click_reload: "Click to reload!",
                close_session: 'Close session',
                bad_url: 'The url entered is incorrect. Check it out',
                login_changepass: "There's a problem with your account, please contact us",
                login_timedout: "There's a problem with your account, please contact us",
                login_exceeded: "There's a problem with your account, please contact us",
                login_no: "Check your username and password"
            }
        },
        va: {
            translation: {
                App: "Aplicació",
                user: "Usuari",
                password: "Contrasenya",
                rememberme: "Recorda'm",
                login: "Login",
                no_login: "Usuari o contrasenya incorrectes",
                spanish: "Espanyol",
                english: "Anglés",
                finished: 'Finalitzat',
                complete: 'Finalitzat',
                screenout: 'Descartada',
                open: 'Abandonament',
                dropout: 'Abandonament',
                discarded: 'Descartada',
                quotafull: 'Quota Plena',
                answer: 'Resposta',
                times: 'Vegades',
                percentage: 'Percentatge',
                quota: 'Quota',
                cross_quotas: 'Creuar quotes',
                percentage_quota: '% Quota',
                missing: 'Falten',
                total: 'Total',
                tracking: 'Seguiment',
                select_form: 'Selecciona una enquesta',
                select_quota: 'Selecciona una quota',
                select_question: 'Selecciona una pregunta',
                all_todas: 'Totes',
                no_data: 'No hi ha dades',
                no_quotas: 'No hi ha quotes',
                no_questions: 'No hi ha preguntes',
                contact_us: 'Contacta amb nosaltres',
                customers: 'Clients',
                outputs: 'Outputs',
                mail: 'Email',
                format: 'Format',
                scheduled: 'Programat',
                file: 'Arxiu',
                type_file: 'Tipus d\'arxiu',
                load: 'Carregar',
                last_update: 'Última actualització',
                survey: 'Enquesta',
                //Tracking
                loi: 'LOI',
                questions: 'Preguntes',
                screenouts: 'Screenouts',
                edit_quotas: 'Editar quotes',
                access: 'Accessos',
                profile_quota: 'Quota perfil',
                //Brandlift
                brandlift: 'Brand Lift',
                channels: 'Canals',
                current_exp: 'Finalitzats EXP',
                total_exp: 'Total EXP',
                current_ne: 'Finalitzats NE',
                total_ne: 'Total NE',
                output_exp: 'EXP',
                output_ne: 'NE',
                report: 'Informe',
                budget: 'Pressupost',
                invoice: 'Factura',
                brandlift_projects: 'Projectes Brand Lift',
                launched: 'Llançat',
                submited: 'Entregat',
                invoiced: 'Facturat',
                paid: 'Pagat',
                pending: 'Pendent',
                past_due: 'Vençut',
                vat: 'IVA',
                amount: 'Quantitat',
                invoice_state: 'Estat de factura',
                //Cati
                change_state: 'Canviar estat',
                begin: 'Començar',
                followup: 'Seguiment',
                more_interviewees: 'Més Entrevistats',
                next_interviewed: 'Següent Entrevistat',
                new_interviewed: 'Nou entrevistat',
                fin_entrevista: 'Fi entrevista',
                no_continua: 'No continua',
                no_contesta: 'No contesta',
                error_fax: 'Error fax',
                error_tlf: 'Error telèfon',
                error_tlf_inc: 'Telèfon incorrecte',
                aplazar: 'Ajornar',
                otros: 'Altres',
                llamar: 'Cridar',
                dar_baja: 'Baixa',
                unsubscribe: 'Donar de baixa',
                asignado: 'Assignat',
                emp_entrevista: 'Començar entrevista',
                cargar_usu: 'Carregar entrevistat',
                cargar_usu_al: 'Carregar entrevistat aleatori',
                interviewed: 'Entrevistat',
                click_begin_hangout: 'Quan la seua cridada siga recepcionada, faça clic en el botó "Començar"',
                calendar: 'Calendari',
                number: 'Número',
                alias: 'Àlies',
                upcoming_events: 'Pròxims esdeveniments',
                no_events: 'No hi ha esdeveniments',
                exists_name_number: 'Ja existix un entrevistat amb este àlies o número',
                empty_name: 'L\'àlies no pot estar buit',
                confirm_unsubscribe: 'Confirma que desitja donar de baixa este entrevistat?',
                //Popups
                add_note: 'Afegir nota',
                logged_as: 'Ha iniciat sessió com',
                logged_in_as: 'Benvingut,',
                user_want_continue: 'Vol continuar amb este usuari?',
                //Menus
                surveys: 'Enquestes',
                projects: 'Projectes',
                start_survey: 'Començar',
                history: 'Historial',
                toogle_theme: 'Canviar tema',
                //Tables
                id: 'ID',
                actions: 'Accions',
                code: 'Codi',
                name: 'Nom',
                desc: 'Descripció',
                summary: 'Resum',
                excel: 'Exportar',
                interviewer: 'Entrevistador',
                planning: 'Planificació',
                start: 'Inici',
                started: 'Inici',
                modified: 'Modificat',
                end: 'Fi',
                state: 'Estat',
                remoteuser: 'Usuari remot',
                note: 'Nota',
                downloads: 'Descarregues',
                //Buttons
                continue: 'Continuar',
                cancel: 'Cancel·lar',
                confirm: 'Confirmar',
                close: 'Tancar',
                change: 'Canviar',
                //Error
                error: 'Ha ocorregut un error, torne a intentar-ho més tard. Si l\'error persistix contacte amb nosaltres. Refresque la pàgina per a continuar',
                went_wrong: "Alguna cosa ha anat malament, l'error ha sigut enviat al nostre equip",
                reload_continue: "Refresque la pàgina per a continuar",
                click_reload: "Faci clic per a refrescar!",
                close_session: 'Tancar sessió',
                bad_url: 'La url introduïda és incorrecta. Comprove-la.',
                login_changepass: "Hi ha un problema amb el seu compte, per favor contacte amb nosaltres",
                login_timedout: "Hi ha un problema amb el seu compte, per favor contacte amb nosaltres",
                login_exceeded: "Hi ha un problema amb el seu compte, per favor contacte amb nosaltres",
                login_no: "Comprove el seu usuari i contrasenya"
            }
        },
        fr: {
            translation: {
                App: "Application",
                user: "Utilisateur",
                password: "Mot de passe",
                rememberme: "Se souvenir de moi",
                login: "Connexion",
                no_login: "Identifiant ou mot de passe incorrect",
                spanish: "Espagnol",
                english: "Anglais",
                finished: 'Terminé',
                complete: 'Terminé',
                screenout: 'Hors cible',
                open: 'Abandon',
                dropout: 'Abandon',
                discarded: 'Rejeté',
                quotafull: 'Quota plein',
                answer: 'Réponse',
                times: 'Fois',
                percentage: 'Pourcentage',
                quota: 'Quota',
                cross_quotas: 'Croiser les quotas',
                percentage_quota: '% Quota',
                missing: 'Manquant',
                total: 'Total',
                tracking: 'Suivi',
                select_form: 'Sélectionner un questionnaire',
                select_quota: 'Sélectionner un quota',
                select_question: 'Sélectionner une question',
                all_todas: 'Tous',
                no_data: 'Aucune donnée',
                no_quotas: 'Aucun quota',
                no_questions: 'Aucune question',
                contact_us: 'Contactez-nous',
                customers: 'Clients',
                outputs: 'Sorties',
                mail: 'E-mail',
                format: 'Format',
                scheduled: 'Planifié',
                file: 'Fichier',
                type_file: 'Type de fichier',
                load: 'Charger',
                last_update: 'Dernière mise à jour',
                survey: 'Enquête',
                //Tracking
                loi: 'DMS',
                questions: 'Questions',
                screenouts: 'Hors cible',
                edit_quotas: 'Modifier les quotas',
                cross_quotas: 'Croiser les quotas',
                access: 'Accès',
                profile_quota: 'Quota profil',
                //Brandlift
                brandlift: 'Brand Lift',
                channels: 'Canaux',
                current_exp: 'Terminés EXP',
                total_exp: 'Total EXP',
                current_ne: 'Terminés NE',
                total_ne: 'Total NE',
                output_exp: 'EXP',
                output_ne: 'NE',
                report: 'Rapport',
                budget: 'Budget',
                invoice: 'Facture',
                brandlift_projects: 'Projets Brand Lift',
                launched: 'Lancé',
                submited: 'Livré',
                invoiced: 'Facturé',
                finished: 'Terminé',
                paid: 'Payé',
                pending: 'En attente',
                past_due: 'Échu',
                vat: 'TVA',
                amount: 'Montant',
                invoice_state: 'Statut de la facture',
                //Cati
                change_state: 'Changer le statut',
                begin: 'Commencer',
                followup: 'Suivi',
                more_interviewees: 'Plus de répondants',
                next_interviewed: 'Répondant suivant',
                new_interviewed: 'Nouveau répondant',
                fin_entrevista: 'Fin de l’entretien',
                no_continua: 'Ne continue pas',
                no_contesta: 'Ne répond pas',
                error_fax: 'Erreur fax',
                error_tlf: 'Erreur téléphone',
                error_tlf_inc: 'Téléphone incorrect',
                aplazar: 'Reporter',
                otros: 'Autres',
                llamar: 'Appeler',
                dar_baja: 'Désabonner',
                unsubscribe: 'Se désabonner',
                asignado: 'Assigné',
                emp_entrevista: 'Commencer l’entretien',
                cargar_usu: 'Charger le répondant',
                cargar_usu_al: 'Charger un répondant aléatoire',
                interviewed: 'Répondant',
                click_begin_hangout: 'Lorsque votre appel est pris en charge, cliquez sur le bouton "Commencer"',
                calendar: 'Calendrier',
                number: 'Numéro',
                alias: 'Alias',
                upcoming_events: 'Événements à venir',
                no_events: 'Aucun événement',
                exists_name_number: 'Un répondant existe déjà avec cet alias ou ce numéro',
                empty_name: 'L’alias ne peut pas être vide',
                confirm_unsubscribe: 'Confirmez-vous vouloir désabonner ce répondant ?',
                //Popups
                add_note: 'Ajouter une note',
                logged_as: 'Vous êtes connecté en tant que',
                logged_in_as: 'Bienvenue,',
                user_want_continue: 'Voulez-vous continuer avec cet utilisateur ?',
                //Menus
                surveys: 'Enquêtes',
                projects: 'Projets',
                start_survey: 'Commencer',
                history: 'Historique',
                toogle_theme: 'Changer de thème',
                //Tables
                id: 'ID',
                actions: 'Actions',
                code: 'Code',
                name: 'Nom',
                desc: 'Description',
                summary: 'Résumé',
                excel: 'Exporter',
                interviewer: 'Enquêteur',
                planning: 'Planification',
                start: 'Début',
                started: 'Début',
                modified: 'Modifié',
                end: 'Fin',
                state: 'Statut',
                remoteuser: 'Utilisateur distant',
                note: 'Note',
                downloads: 'Téléchargements',
                //Buttons
                continue: 'Continuer',
                cancel: 'Annuler',
                confirm: 'Confirmer',
                close: 'Fermer',
                change: 'Changer',
                //Error
                error: 'Une erreur est survenue, veuillez réessayer plus tard. Si l’erreur persiste, contactez-nous. Actualisez la page pour continuer',
                went_wrong: "Quelque chose s’est mal passé, l’erreur a été envoyée à notre équipe",
                reload_continue: "Actualisez la page pour continuer",
                click_reload: "Cliquez pour actualiser !",
                close_session: 'Déconnexion',
                bad_url: 'L’URL saisie est incorrecte. Veuillez la vérifier.',
                login_changepass: "Il y a un problème avec votre compte, veuillez nous contacter",
                login_timedout: "Il y a un problème avec votre compte, veuillez nous contacter",
                login_exceeded: "Il y a un problème avec votre compte, veuillez nous contacter",
                login_no: "Vérifiez votre identifiant et votre mot de passe"
            }
        },
    },
    lng: 'va', 
    fallbackLng: "va",
    load: 'languageOnly',
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

setupIonicReact();

function App() {
  const { token, setToken } = useToken();
  const [modalOpen, setModalOpen] = useState(false);

  const { t } = useTranslation();
  const queryString = window.location.search;

  //document.documentElement.lang = i18n.resolvedLanguage;
  document.documentElement.lang = "va";

  //const urlParams = new URLSearchParams(queryString);
  //const urlParams = new URLSearchParams("?project=1067&qa=1");

  

  /*if(!token) {
    return <Login setToken={setToken} />
  }*/
  useEffect(() => {
    //themeDetector();

    if(token != null && token.r == 4) {
        const observer = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
            if (entry.type === "navigate") {
                setModalOpen(true);
            }
            });
        });

        observer.observe({ type: "navigation", buffered: true });
    }
  }, []);
  
return (
    <IonApp>
        {/*<SqliteServiceContext.Provider value={SqliteService}>
            <DbVersionServiceContext.Provider value={DbVersionService}>
                <StorageServiceContext.Provider value={new StorageService(SqliteService,DbVersionService)}>
                    <AppInitializer setToken={setToken}>
                        {token == null ? <Login setToken={setToken} /> : <Dashboard token={token} setToken={setToken} />}
                    </AppInitializer>
                </StorageServiceContext.Provider>
            </DbVersionServiceContext.Provider>
</SqliteServiceContext.Provider>*/}
        
        {token == null ? 
            <ErrorBoundary><Login setToken={setToken} setModalOpen={setModalOpen}/></ErrorBoundary> 
            : <ErrorBoundary>
                <Dashboard token={token} setToken={setToken} />
                <IonModal isOpen={modalOpen}>
                    <IonHeader>
                        <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton onClick={(e) => {
                                    e.preventDefault();
                                    setModalOpen(false);
                                    setToken(null);
                                }
                            }>{t('change')}</IonButton>
                        </IonButtons>
                        <IonButtons slot="end">
                            <IonButton strong={true} onClick={(e) => {
                                    e.preventDefault();
                                    setModalOpen(false);
                                }}>{t('continue')}
                            </IonButton>
                        </IonButtons>
                        </IonToolbar></IonHeader>
                    <IonContent className="ion-padding text-center">
                        <div className="h-100 align-content-center">
                            <h3>{t('logged_as')} <span className='color-orange'><b>{token.name}</b></span></h3>
                            <h3>{t('user_want_continue')}</h3>
                            <img className='mt-5' src={CardImg} alt={t('bn_squared_logo')}/>
                        </div>
                    </IonContent>
                </IonModal>
            </ErrorBoundary>
            }
    </IonApp>
);
  /*return (
    <Dashboard />
  );*/
}

export default App;